import React from 'react';
import PropTypes from 'prop-types';
import { Box, ButtonBase, CircularProgress, Typography } from '@mui/material';

import { styled } from '@mui/material/styles';

const ModuleButton = props => {
  const { children, component, disabled, icon, loading, to } = props;
  const ButtonProgress = styled(CircularProgress)(({ theme }) => ({
    color: theme.palette.secondary.main,
    margin: 'auto',
    pointerEvents: 'none',
  }));

  const Icon = styled(Box)(({ theme }) => ({
    '& > svg > g > path, & > svg > path': {
      fill: !disabled && !loading ? theme.palette.secondary.main : theme.palette.graphic.main,
    },
    alignItems: 'center',
    backgroundColor:
      !disabled && !loading ? theme.palette.secondary.medium : theme.palette.graphic.light,
    borderRadius: '4px 4px 0 0',
    display: 'flex',
    height: 179,
    justifyContent: 'center',
    width: '100%',
  }));

  const Root = styled(ButtonBase)(({ theme }) => ({
    '&:hover': {
      boxShadow: theme.shadows[6],
    },
    borderRadius: 4,
    boxShadow: theme.shadows[1],
    flexDirection: 'column',
    height: 254,
    margin: theme.spacing(1.5),
    width: 254,
  }));

  const Title = styled(Typography)(({ theme }) => ({
    color: disabled || loading ? theme.palette.text.disabled : theme.palette.common.black,
    fontWeight: 400,
  }));

  const TitleContainer = styled(Box)(() => ({
    alignItems: 'center',
    borderRadius: '0 0 4px 4px',
    display: 'flex',
    height: 75,
    justifyContent: 'center',
    width: '100%',
  }));
  return (
    <Root component={component} disabled={disabled || loading} to={to}>
      <Icon className="heap-card">{loading ? <ButtonProgress size={80} /> : icon}</Icon>
      <TitleContainer>
        <Title variant="h4">{children}</Title>
      </TitleContainer>
    </Root>
  );
};

ModuleButton.propTypes = {
  children: PropTypes.node.isRequired,
  component: PropTypes.shape({}),
  disabled: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  loading: PropTypes.bool,
  to: PropTypes.string,
};
ModuleButton.defaultProps = {
  component: undefined,
  disabled: false,
  loading: false,
  to: undefined,
};

export default ModuleButton;
